module.exports = __webpack_public_path__ + "static/media/mosque.a35c050a.jpg";